import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';  
import Layer1 from "../../../assests/Layer_1.png"
import group1 from "../../../assests/Vector.png";
import circle from "../../../assests/Group3702.png";

export const SubdomainCard = ({ subdomain, onClick, linkTo }) => {
  const scoreValue = parseFloat(subdomain.score.replace('%', ''));
  const isEmpty = parseInt(subdomain.assets || 0) === 0 && parseInt(subdomain.product_count || 0) === 0;

  const handleClick = (e) => {
    if (isEmpty) {
      e.preventDefault();
      return;
    }
    const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0;
    if (isModifiedClick) return;
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Link
      to={isEmpty ? '#' : (linkTo || '#')}
      onClick={handleClick}
      style={{ pointerEvents: isEmpty ? 'none' : 'auto' }}
      className="bg-white rounded-lg border border-gray-200 hover:shadow-lg hover:border-blue-300 transition-all duration-200 cursor-pointer group mr-[20px] ml-[20px]"
    >
      <div style={{width:"100%"}} className="flex justify-between bg-gray-100 border-b border-gray-200 p-4 ">
        <div className="flex-1">
          <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <img src={Layer1} alt='layer' />
          <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-200 truncate max-w-[200px]">
              {subdomain.name}
            </h3>
          </div>

          <p 
            className="text-sm text-black mt-1 line-clamp-1"
            title={subdomain.description}
          >
            {subdomain.description}
          </p>
          </div>
        </div>
          <ChevronRight className="group-hover:text-blue-500 transition-colors duration-200 ml-4 flex-shrink-0 cursor-pointer" />
      </div>
      {/* Stats */}
      <div className="grid grid-cols-2 gap-2 p-4 ">
        <div className="flex items-center space-x-2">
          <div className="p-2 bg-blue-50 rounded-lg">
            <img src={circle} className='bg-[#FF2897] p-3 h-[50px]' />
          </div>
          <div>
            <p className="text-[13px] text-black">Assets</p>
            <p className="text-sm font-semibold text-gray-900">
              {parseInt(subdomain.assets || 0).toLocaleString()}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div className="p-2 bg-green-50 rounded-lg">
            <img src={group1}  className='bg-[#63B945] p-3 h-[50px] ' />
          </div>
          <div>
            <p className="text-[13px] text-black">Products</p>
            <p className="text-sm font-semibold text-gray-900">
              {parseInt(subdomain.product_count || 0).toLocaleString()}
            </p>
          </div>
        </div>
      </div>

      {/* Quality Score Bar */}
      <div className="p-4 ">
        <div className="flex items-center justify-between  mb-1">
          <span className='text-black'>Quality Score</span>
          <span className='text-black'>{subdomain.score}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div 
            className={`h-2 rounded-full transition-all duration-300 ${
              scoreValue > 95 ? 'bg-green-700' : 
              scoreValue > 90 ? 'bg-yellow-700' :
               scoreValue < 90 ? 'bg-red-500' :'bg-gray-500'
            }`}
            style={{ width: `${scoreValue}%` }}
          />
        </div>
      </div>
    </Link>
  );
};